const apis = {
  getLineList: {
    url: '/api/assembly_line',
    name: 'GET_LINE_LIST',
  },
  getLine: {
    url: '/api/assembly_line/machine',
    name: 'GET_LINE',
  },
};

export default apis;
